const login = {
  password: 'Password',
  login: 'Login',
  sign_in: 'Sign In',
  click_msg: 'By clicking Sign In, you agree to our',
  terms: 'Terms and Conditions',
  and: 'and',
  privacy: 'Privacy Policy',
  account_msg: 'Dont have an acount?',
  register_here: 'Register here',
  sign_in_error: 'An error occurred. Please try signing in again...',
  cloud_based_title: 'Cloud-Based Access Control System',
};

export default login;
